<template>
  <div>
    <form class="section__content form">
      <h1 class="admin__title">Formats ({{ allFormats.length }})</h1>
      <fieldset class="form__group" v-if="!currentFormat">
        <section class="form__item__input input">
          <input placeholder="Search for ad formats here..." type="text" class="input__field" v-model="filter"/>
        </section>
        <article v-for="(ad, index) in filterAllFormats" class="form__category form__item form__item--show-border" :key="index">
          <label class="form__item__label">
            <h1 class="form__item__name"><strong>{{ ad.name }}</strong></h1>
          </label>
          <label for="form__item__label">
            <SeriesBadge :series="ad.series" :box="true"/>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name form__item__series-right">{{ isVisible(ad.visible) }}</h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">{{ isPremium(ad.premium) }}</h1>
          </label>
          <section class="form__item__input input">
            <div @click="editDemoPage(ad)" class="button button--secondary">Edit Format</div>
          </section>
          <section class="form__item__input input">
            <div @click="refreshAd(ad.id)" class="admin__button--primary button button--primary">Refresh Ad Code</div>
          </section>
        </article>
      </fieldset>
      <fieldset class="form__group" v-if="currentFormat">
        <h2>{{ currentFormat.name }}</h2>
        <hr>
        <article class="form__item form__item--show-border series-container">
          <label class="form__item__label series-left">
            <h1 class="form__item__name">Name</h1>
            <small class="form__item__name">This is the ad name that will overwrite the name from Broadstreet.</small>
          </label>
          <SeriesBadge :series='currentFormat.series' :box='true'/>
          <section class="form__item__input input">
            <input type="text" class="input__field" :defaultValue="name" v-model="name" />
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Description</h1>
            <small class="form__item__description">This is the ad description that will overwrite the description from Broadstreet.</small>
          </label>
          <section class="form__item__input input">
            <textarea type="text" class="input__field" :defaultValue="description" v-model="description"></textarea>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Visibility</h1>
            <small class="form__item__description">This is the ad visibility that will toggle whether the ad can be seen by ParkAve users or not.</small>
          </label>
          <section class="form__item__input input">
            <h1 class="form__item__name">{{ isVisible(visible) }}</h1>
          </section>
          <section class="form__item__input input">
            <div class="button button--primary" v-if="!visible" @click="visible = !visible">Make Visible</div>
            <div class="button button--remove" v-if="visible" @click="visible = !visible">Make Invisible</div>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Premium Ad Format?</h1>
            <small class="form__item__description">This is the premium ad status that will toggle whether the ad is a premium format that can be used by only Pro users and above.</small>
          </label>
          <section class="form__item__input input">
            <h1 class="form__item__name">{{ isPremium(premium) }}</h1>
          </section>
          <section class="form__item__input input">
            <div class="button button--primary" v-if="!premium" @click="premium = !premium">Make Premium Format</div>
            <div class="button button--remove" v-if="premium" @click="premium = !premium">Make Regular Format</div>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Category Sort Id</h1>
            <small class="form__item__description">This is a number id that sorts the categories when they are displayed on the homepage list. The smaller the number the higher on the list it will appear.</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="number" class="input__field"  v-model="sort">
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Media Kit</h1>
            <small class="form__item__description">Paste in the HTML code or type out the text that will make up the Media Kit for the Demo Page</small>
          </label>
          <section class="form__item__input input">
            <rich-text :id="'mediaKit'" :defaultValue="mediaKit" @input="updateMediaKit"></rich-text>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Design Details</h1>
            <small class="form__item__description">Paste in the HTML code or type out the text that will make up the Design Details for the Demo Page</small>
          </label>
          <section class="form__item__input input">
            <rich-text :id="'designerInfo'" :defaultValue="designerInfo" @input="updateDesignerInfo"></rich-text>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Preview Image</h1>
            <small class="form__item__description">Here you can override the preview image of the format.</small>
          </label>
          <section class="form__item__input input">
            <image-upload :id="'formatPreviewImage'" v-model="preview_image" :defaultValue="preview_image"></image-upload>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <a href="#" v-on:click.prevent="saveDemoData" class="section__footer__button admin__button--primary button button--primary">Save</a>
          <a href="#" v-on:click.prevent="cancelEditDemoPage" class="section__footer__button section__footer__button--right button button--secondary">Cancel</a>
          <a href="#" v-on:click.prevent="deleteFormat" class="admin__button section__footer__button section__footer__button--right button button--remove">Delete Format</a>
        </article>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import RichText from '../common/RichText'
  import ImageUpload from '../common/ImageUpload'
  import { getAllFormats } from "../../lib/api/calls";
  import {mapState} from 'vuex'
  import SeriesBadge from '../common/SeriesBadge'

  export default {
    name: 'AdminFormats',
    components: {
      'rich-text': RichText,
      ImageUpload,
      SeriesBadge
    },
    data () {
      return {
        formats: [],
        currentFormat: null,
        mediaKit: '',
        designerInfo: '',
        name: '',
        description: '',
        visible: null,
        premium: null,
        preview_image: null,
        sort: null,
        filter: ''
      }
    },
    methods: {
      deleteFormat () {
        this.$modal.show('warning', {
          messageText: 'Are you sure you want to delete the selected format?? BE CAREFUL HERE!!!!!',
          buttonText: 'Delete Format',
          callback: function (params) {
            this.$store.dispatch('formats/delete', this.currentFormat.id);
            this.cancelEditDemoPage();
          }.bind(this)
        })
      },
      isVisible (visible) {
        if (visible) {
          return 'Visible'
        } else {
          return 'Not Visible'
        }
      },
      isPremium (premium) {
        if (premium) {
          return 'Premium'
        } else {
          return 'Normal'
        }
      },
      editDemoPage (format) {
        this.currentFormat = format;
        this.mediaKit = format.media_kit;
        this.designerInfo = format.designer_info;
        this.name = format.name;
        this.description = format.description;
        this.visible = format.visible;
        this.premium = format.premium;
        this.preview_image = {sizes: {}, url: format.preview_image};
        this.sort = format.sort;
      },
      cancelEditDemoPage () {
        this.currentFormat = null;
        this.mediaKit = '';
        this.designerInfo = '';
        this.name = '';
        this.description = '';
        this.visible = null;
        this.premium = null;
        this.preview_image = null;
        this.sort = null;
      },
      saveDemoData () {
        let demo = this;
        let previewImg;
        if (this.preview_image.sizes[800]) {
          previewImg = this.preview_image.sizes[800].url
        } else if (this.preview_image) {
          previewImg = this.preview_image;
        } else {
          previewImg = null;
        }
        let payload = {
          media_kit: this.mediaKit,
          designer_info: this.designerInfo,
          name: this.name,
          description: this.description,
          visible: this.visible,
          premium: this.premium,
          preview_image: previewImg,
          sort: this.sort
        };
        this.$store.dispatch('formats/update', {id: this.currentFormat.id, payload: payload, callback: (response)=>{demo.cancelEditDemoPage();
        }}, this.$snotify);
      },
      refreshAd (formatId) {
        this.$store.dispatch('advertisements/regenerate', formatId);
      },
      updateMediaKit(newVal) {
        this.mediaKit = newVal;
      },
      updateDesignerInfo(newVal) {
        this.designerInfo = newVal;
      }
    },
    computed: {
      ...mapState('formats', ['allFormats']),
      filterAllFormats (filter) {
        return this.allFormats.filter(format => {
          return format.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        })
      }
    },
    mounted () {
      if (this.$route.query.id) {
        let format;
        getAllFormats().then((formats) => {
          format = formats.filter(format => format.id == this.$route.query.id)
          this.editDemoPage(format[0])
        })
      }
    }
  }
</script>

<style scoped>
  .button--primary {
    color: white !important;
  }

  .form__item__input {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminFormats.vue